const electronRoute = "/electron";
export const electroneApi = `${electronRoute}-api`;
export default electronRoute;
